export const SMART_SEARCH_PATH = 'smart-search';
export const SMART_SEARCH_FEATURE_TOGGLE = 'smart-search-ISD-16248';
